import { render, staticRenderFns } from "./lotterydetails.mixins.vue?vue&type=template&id=a5dc2908"
import script from "./lotterydetails.mixins.vue?vue&type=script&lang=js"
export * from "./lotterydetails.mixins.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports